import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ez-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss'],
  standalone: false,
})
export class SurveyComponent {
  protected readonly matDialogData = inject<string>(MAT_DIALOG_DATA);
  readonly #matDialogRef = inject<MatDialogRef<SurveyComponent>>(MatDialogRef);

  dismissForever(): void {
    localStorage.surveyDismissed = this.matDialogData;
    this.#matDialogRef.close();
  }
}
